module.exports = __webpack_public_path__ + "img/logo.6f82255e.svg";